module.exports = __webpack_public_path__ + "assets/img/tab_4.d3ec5b1f.png";